import React, { Suspense } from 'react'

import { Switch, Route, Redirect } from 'react-router-dom'

import { Navbar } from '_components/navbar'
import { PrivateRoute } from '_components/private-route'
import { AuthFail } from '_legacy/components/authentication/authFailure'
import { SSOFailure } from '_legacy/components/authentication/ssoFailure'
import { ReportDashboard } from '_legacy/components/practiceReports'
import { PracticeReportsLanding } from '_legacy/components/practiceReportsLanding'
import SSORedirectListener from '_helpers/sso-redirect-listener'

import { LoadingPage } from './LoadingPage'
import SsoLogin from './SsoLogin/SsoLogin'

const LoginPage = React.lazy(() => import('_legacy/containers/signInUser'))
const MemberSearchPage = React.lazy(() => import('_legacy/containers/memberSearch'))
const PlanPage = React.lazy(() => import('_legacy/containers/plan'))
const PracticePage = React.lazy(() => import('_legacy/containers/practice'))
const LogoutPage = React.lazy(() => import('_legacy/containers/logout'))
const ForgetPasswordPage = React.lazy(() => import('_legacy/containers/forgetPassword'))
const ResetPasswordPage = React.lazy(() => import('_legacy/containers/resetPassword'))
const ReferralManagementContainer = React.lazy(() => import('./ReferralManagement'))
const PracticeReportsContainer = React.lazy(() => import('_legacy/containers/practiceReports'))

export const Routes = () => (
  <>
    <Navbar />
    <main className="member-page">
      <Suspense fallback={<LoadingPage />}>
        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/sso" component={SsoLogin} />
          <Route
            exact
            path="/forgetPassword"
            render={() => (
              <ForgetPasswordPage
                title="Forgot your password?"
                description="Please enter your email, and we will send you a verification"
              />
            )}
          />
          <Route
            exact
            path="/newUserVerification"
            render={() => (
              <ForgetPasswordPage
                title="New User Verification"
                description="Please enter your email, and we will verify your account"
                newUser
              />
            )}
          />
          <Route exact path="/resetPassword" component={ResetPasswordPage} />
          <PrivateRoute path="/member-search" component={MemberSearchPage} />
          <PrivateRoute
            exact
            path="/referral-management"
            component={ReferralManagementContainer}
          />
          <PrivateRoute
            exact
            path="/practice-profile"
            component={PracticePage}
          />
          <Route
            exact
            path="/practice-reports/:taxId?"
            render={() => (
              <PracticeReportsContainer>
                <PracticeReportsLanding />
              </PracticeReportsContainer>
            )}
          />
          <Route
            exact
            path="/practice-reports/:taxId/dashboard"
            render={() => (
              <PracticeReportsContainer>
                <ReportDashboard />
              </PracticeReportsContainer>
            )}
          />
          <PrivateRoute exact path="/plan" component={PlanPage} />
          <PrivateRoute
            exact
            path="/practice"
            component={PracticeReportsContainer}
          />
          <PrivateRoute exact path="/logout" component={LogoutPage} />
          <Route exact path="/auth-failed" component={AuthFail} />
          <Route exact path="/sso-failed" component={SSOFailure} />
          <Route path="/" component={SSORedirectListener} />
        </Switch>
      </Suspense>
    </main>
  </>
)
